export default __webpack_public_path__ + "static/media/CL03.1.1335f7ba.mp3";